export default {
    culture: String, 
    dates: Array, 
    depth: String, 
    disableDates: Array | Function, 
    footer: String | Function, 
    format: String, 
    max: Date, 
    messages: Object, 
    min: Date, 
    month: Object, 
    selectable: String, 
    selectDates: Array, 
    weekNumber: Boolean, 
    start: String, 
    value: Date, 

    // Events
    change: Function, 
    navigate: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoCalendar/CalendarProps.js